import { AgentRunOutcome } from './tools/report-outcome.js';
export { AgentRunOutcome };
export var AgentRunStatus;
(function (AgentRunStatus) {
    AgentRunStatus["Pending"] = "PENDING";
    AgentRunStatus["Running"] = "RUNNING";
    AgentRunStatus["AwaitingApproval"] = "AWAITING_APPROVAL";
    AgentRunStatus["Completed"] = "COMPLETED";
    AgentRunStatus["Failed"] = "FAILED";
    AgentRunStatus["Exhausted"] = "EXHAUSTED";
    AgentRunStatus["Cancelled"] = "CANCELLED";
})(AgentRunStatus || (AgentRunStatus = {}));
export var AgentToolCallStatus;
(function (AgentToolCallStatus) {
    AgentToolCallStatus["Proposed"] = "PROPOSED";
    AgentToolCallStatus["Executing"] = "EXECUTING";
    AgentToolCallStatus["Executed"] = "EXECUTED";
    AgentToolCallStatus["Rejected"] = "REJECTED";
    AgentToolCallStatus["Failed"] = "FAILED";
    AgentToolCallStatus["Stale"] = "STALE";
    AgentToolCallStatus["Superseded"] = "SUPERSEDED";
    AgentToolCallStatus["Dismissed"] = "DISMISSED";
})(AgentToolCallStatus || (AgentToolCallStatus = {}));
export var HeavyResponseStatus;
(function (HeavyResponseStatus) {
    HeavyResponseStatus["Proposed"] = "proposed";
    HeavyResponseStatus["AutoApplied"] = "auto_applied";
})(HeavyResponseStatus || (HeavyResponseStatus = {}));
export const DEFAULT_AGENT_RUN_LIMITS = {
    maxWallClockSeconds: 600,
    maxInputTokensPerTurn: 100_000,
    maxCredits: 5,
};
export var AgentNoticeKind;
(function (AgentNoticeKind) {
    AgentNoticeKind["HumanEscalation"] = "HUMAN_ESCALATION";
    AgentNoticeKind["SystemFailure"] = "SYSTEM_FAILURE";
})(AgentNoticeKind || (AgentNoticeKind = {}));
export var AgentNoticeReferenceType;
(function (AgentNoticeReferenceType) {
    AgentNoticeReferenceType["Case"] = "CASE";
})(AgentNoticeReferenceType || (AgentNoticeReferenceType = {}));
export var AgentNoticeSourceType;
(function (AgentNoticeSourceType) {
    AgentNoticeSourceType["EscalationTool"] = "ESCALATION_TOOL";
    AgentNoticeSourceType["RunOutcome"] = "RUN_OUTCOME";
    AgentNoticeSourceType["RunFailure"] = "RUN_FAILURE";
})(AgentNoticeSourceType || (AgentNoticeSourceType = {}));
//# sourceMappingURL=runs.js.map